/** 表プレビューで共有する寸法。furikake/MUI のテーマ spacing を基準にする(px ハードコードはしない)。 */
import type { Theme } from '@mui/material/styles'

/**
 * 条件を表示する帯(多段ヘッダーの上段)1 段の高さ。列見出しは深さ分だけこの高さを下にずらして固定する。
 * headerStickyTop がこの値で段の固定位置を計算するため、帯の中身がこの高さを超えると段がずれる。
 * 帯に置く要素は BAND_CONTENT_HEIGHT に揃えること。
 */
export const CONDITION_BAND_HEIGHT = (theme: Theme): string => theme.spacing(3)

/** 帯の中に置く要素(番号チップ・削除ボタン)の高さ。帯の高さからボーダー分を引いても収まる値にする。 */
export const BAND_CONTENT_HEIGHT = (theme: Theme): string => theme.spacing(2.5)

/** ヘッダー depth 段目(0 始まり)のセルを sticky で固定する位置。上に帯が depth 本ある。 */
export const headerStickyTop = (theme: Theme, depth: number): string =>
  `calc(${CONDITION_BAND_HEIGHT(theme)} * ${depth})`

/** ヘッダー(列見出し)の高さ。 */
export const HEADER_CELL_HEIGHT = (theme: Theme): string => theme.spacing(7)

/** 本体セルの高さ。 */
export const BODY_CELL_HEIGHT = (theme: Theme): string => theme.spacing(7)

/**
 * 列の固定幅。内容が伸びても列幅を変えないよう、全セルで width/min/max を揃える。
 * 質問名はこの幅に収まらない分を 2 行で折り返し、それを超えると省略する。
 */
export const columnWidthSx = (theme: Theme) => {
  const width = theme.spacing(45)
  return { width, minWidth: width, maxWidth: width }
}

/** 見出し列の幅。表示中は回答列と同じ固定幅にし、非表示のときは「見出し非表示」と操作メニューが収まる幅まで縮める。 */
export const rowHeadingWidthSx = (theme: Theme, hidden: boolean) =>
  hidden
    ? { width: 'auto', minWidth: 0, maxWidth: 'none' }
    : columnWidthSx(theme)
